const LEGACY_ROLE_PARTS = [1000, 100, 10, 2, 1];

export const splitLegacyRole = (value: number): number[] => {
    let remaining = Number(value || 0);
    const roles: number[] = [];
    LEGACY_ROLE_PARTS.forEach((role) => {
        if (remaining >= role) {
            remaining -= role;
            roles.push(role);
        }
    });
    return remaining === 0 ? roles : [value];
};

export const hasLegacyRole = (value: number, role: number) =>
    splitLegacyRole(value).includes(role);

export const canUseRecipientLists = (value: number) =>
    hasLegacyRole(value, 10) || hasLegacyRole(value, 100) || hasLegacyRole(value, 1000);

export const isAdminOrAbove = (value: number) =>
    hasLegacyRole(value, 100) || hasLegacyRole(value, 1000);
